import { render } from "./CertificateContent.vue?vue&type=template&id=729f3d48"
import script from "./CertificateContent.vue?vue&type=script&lang=js"
export * from "./CertificateContent.vue?vue&type=script&lang=js"

import "./CertificateContent.vue?vue&type=style&index=0&id=729f3d48&lang=css"
script.render = render

export default script